var Flickity = require('flickity-imagesloaded');

function FeaturedPress(el) {
  var t = this;
  t.el = el;
  t.list = t.el.querySelector('[data-featured-press-list]');
  t.flickity = new Flickity(t.list, {
    imagesLoaded: true,
    prevNextButtons: false,
    adaptiveHeight: true,
    watchCSS: true
  });
}

module.exports = FeaturedPress;
